// extracted by mini-css-extract-plugin
export default {"projectsContainer":"Projects_projectsContainer__wfiKe","bestIcon":"Projects_bestIcon__rngJs","greenIcon":"Projects_greenIcon__s3SV9","postrIcon":"Projects_postrIcon__eU+2q"};